import API from "../Common/Endpoint/serviceConstrants";
import axiosInstanceClient from '../Common/Axios/axiosInstanceClient'
export const memberApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.post(API.member, payload);
  return data;
};

export const memberApiGet = async (payload) => {
  const { data = {} } = await axiosInstanceClient.get(API.memberById,{
    params: {
      MemberId:payload
    }
  });
  return data;
};

